import { Image, StyleSheet, View } from '@react-pdf/renderer';

import goldStar from '@/assets/images/gold-star.png';
import grayStar from '@/assets/images/gray-star.png';

const styles = StyleSheet.create({
  container: {
    rowGap: 3,
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'flex-end',
    justifyContent: 'center',
    marginTop: 10,
  },
  imageSideGold: {
    width: 42,
    height: 42,
    marginHorizontal: 45,
    alignSelf: 'center',
    marginTop: 10,
  },
  imageSideGray: {
    width: 16,
    height: 16,
    alignSelf: 'center',
    marginHorizontal: 85,
    marginTop: 20,
  },
  imageHalfCenterGold: {
    alignSelf: 'center',
    marginTop: -10,
    width: 50,
    height: 50,
  },
  imageHalfCenterGray: {
    marginHorizontal: 15,
    alignSelf: 'center',
    width: 24,
    height: 24,
  },
  imageCenterGold: {
    marginHorizontal: '-100px',
    marginBottom: 8,
    width: 76,
    height: 76,
    alignSelf: 'center',
    marginTop: -20,
  },
  imageCenterGray: {
    marginTop: -4,
    width: 30,
    height: 30,
    alignSelf: 'flex-start',
  },
});

type RateStarPdfProps = { percent: number };
export const RateStarPdf: React.FC<RateStarPdfProps> = ({ percent }) => {
  return (
    <View style={styles.container}>
      {percent >= 98 ? (
        <Image style={styles.imageSideGold} src={goldStar} />
      ) : (
        <Image
          style={{
            ...styles.imageSideGold,
            marginHorizontal: percent >= 33 ? 60 : 0,
            marginTop: percent >= 33 ? 0 : 20,
            width: 16,
            height: 16,
          }}
          src={grayStar}
        />
      )}

      {percent > 66.6 ? (
        <Image
          style={{
            ...styles.imageHalfCenterGold,
            marginHorizontal: percent >= 33 ? 3 : 5,
          }}
          src={goldStar}
        />
      ) : (
        <Image
          style={{
            ...styles.imageHalfCenterGray,
            marginTop: percent >= 33 ? -20 : 0,
          }}
          src={grayStar}
        />
      )}

      {percent > 33.3 ? (
        <Image style={styles.imageCenterGold} src={goldStar} />
      ) : (
        <Image style={styles.imageCenterGray} src={grayStar} />
      )}

      {percent > 66.6 ? (
        <Image
          style={{
            ...styles.imageHalfCenterGold,
            marginHorizontal: percent >= 33 ? 3 : 5,
          }}
          src={goldStar}
        />
      ) : (
        <Image
          style={{
            ...styles.imageHalfCenterGray,
            marginTop: percent >= 33 ? -20 : 0,
          }}
          src={grayStar}
        />
      )}

      {percent >= 98 ? (
        <Image style={{ ...styles.imageSideGold }} src={goldStar} />
      ) : (
        <Image
          style={{
            ...styles.imageSideGold,
            marginHorizontal: percent >= 33 ? 60 : -0,
            marginTop: percent >= 33 ? 0 : 20,
            width: 16,
            height: 16,
          }}
          src={grayStar}
        />
      )}
    </View>
  );
};
